const translations = {
  // ===== NAVIGATION =====
  nav: {
    home: { en: 'HOME', sv: 'HEM' },
    events: { en: 'EVENTS', sv: 'EVENEMANG' },
    recording: { en: 'RECORDING', sv: 'INSPELNING' },
    labs: { en: 'LABS', sv: 'LABS' },
    hire: { en: 'HIRE', sv: 'BOKA' },
    accommodation: { en: 'ACCOMMODATION', sv: 'BOENDE' },
    shop: { en: 'SHOP', sv: 'BUTIK' },
    info: { en: 'INFO', sv: 'INFO' },
    login: { en: 'LOGIN', sv: 'LOGGA IN' },
    signOut: { en: 'SIGN OUT', sv: 'LOGGA UT' },
  },

  // ===== HOME / TAGLINE =====
  home: {
    tagline1: {
      en: 'Idea Farm is a 900m² arts complex located in a cluster of 1920s cow barns on the edge of Söderåsen national park, near Malmö, Sweden.',
      sv: 'Idea Farm är ett 900 m² stort konst- och kreativitetskomplex beläget i en samling 1920-tals ladugårdar vid kanten av Söderåsen nationalpark, nära Malmö.',
    },
    tagline2: {
      en: 'With a world-class recording studio, creative design labs, pop-up kitchen, nutritional therapy clinic, event spaces, and a focus on community collaboration, we work to promote human interaction in a post-digital world.',
      sv: 'Med en inspelningsstudio i världsklass, kreativa designlabb, pop-up-kök, klinik för näringsterapi och flexibla evenemangsytor, fokuserar vi på samarbete och gemenskap – och på att främja mänsklig interaktion i en post-digital tid.',
    },
  },

  // ===== EVENT PANELS =====
  eventPanels: {
    upNext: { en: 'UP NEXT', sv: 'NÄSTA' },
    comingUp: { en: 'COMING UP', sv: 'PÅ GÅNG' },
    happening: { en: 'HAPPENING', sv: 'HÄNDER' },
    event: { en: 'Event', sv: 'Evenemang' },
    comingSoon: { en: 'Coming soon...', sv: 'Kommer snart...' },
    recordingSessions: { en: 'Recording Sessions', sv: 'Inspelningssessioner' },
    recordingSubtitle: { en: 'Professional recording in our 170m² studio', sv: 'Professionell inspelning i vår 170 m² stora studio' },
    outdoorDining: { en: 'Outdoor Dining', sv: 'Utomhusmiddag' },
    outdoorSubtitle: { en: 'Courtyard events with countryside views', sv: 'Evenemang på gården med utsikt över landsbygden' },
    checkLatestVideo: { en: 'Check out our latest video!', sv: 'Kolla in vår senaste video!' },
  },

  // ===== RECORDING PAGE =====
  recording: {
    para1: {
      en: 'At the heart of Idea Farm is our 170m² recording studio – a uniquely creative environment built inside a beautifully restored wooden cow barn. With an enormous 8m high recording room, spacious drum booth, and a nod to the great studios of the 50s and 60s, the studio houses a huge collection of musical toys from the past, present, and future.',
      sv: 'I hjärtat av Idea Farm finns vår 170 m² stora inspelningsstudio — en unik, kreativ miljö byggd i en vackert restaurerad trä-ladugård. Med ett enormt inspelningsrum på 8 meters takhöjd, rymlig trumhytt och en hyllning till de stora studiorna från 50- och 60-talet, rymmer studion en omfattande samling musikaliska "leksaker" från dåtid, nutid och framtid.',
    },
    para2: {
      en: 'Perfect for full band sessions, orchestral recordings, live performances, and immersive production work, the rooms combine exceptional acoustics with an inviting, characterful atmosphere. Overlooking the main room is a 4m high gallery fitted with 18 original 1940s cinema chairs – ideal for intimate concerts, film screenings, or behind the scenes viewing.',
      sv: 'Perfekt för fullbandinspelningar, orkesterproduktioner, liveframträdanden och immersiv ljudproduktion, kombinerar rummen enastående akustik med en inbjudande och karaktärsfull atmosfär. Över huvudinspelningsrummet finns en 4 meter hög balkong utrustad med 18 original biostolar från 1940-talet — perfekt för intima konserter, filmvisningar eller för att följa inspelningen bakom kulisserna.',
    },
    bio: {
      en: 'Robbie Moore is a London-born Producer Engineer/Multi-Instrumentalist, with over 25 years experience building and running studios in London, Berlin and now Sweden, writing music for film/TV and recording artists from a variety of genres.',
      sv: 'Robbie Moore är Londonfödd producent, ljudtekniker och multiinstrumentalist med över 25 års erfarenhet av att bygga och driva studior i London, Berlin och nu Sverige. Han skriver musik för film och TV samt spelar in artister inom en mängd olika genrer.',
    },
    bioCredits: {
      en: 'He has worked with acts such as Little Simz, Peaches, Florence + The Machine, Glen Matlock, L.A. Salami, Jesper Munk, Gemma Ray, Donny Benet, Plattenbau and Anika among many others.',
      sv: 'Han har samarbetat med artister som Little Simz, Peaches, Florence + The Machine, Glen Matlock, L.A. Salami, Jesper Munk, Gemma Ray, Donny Benet, Plattenbau och Anika, bland många andra.',
    },
    hireLine1: {
      en: 'Studio available as a dry hire or with house engineer/producer',
      sv: 'Studion finns tillgänglig för egen hyra eller med vår husproducent/ljudtekniker.',
    },
    hireLine2: {
      en: 'Drop us a line',
      sv: 'Kontakta oss',
    },
    hireLine2Suffix: {
      en: 'for deals, dates & rates!',
      sv: 'för erbjudanden, tillgängliga datum och priser!',
    },
    here: { en: 'here', sv: 'här' },
  },

  // ===== LABS PAGE =====
  labs: {
    para1: {
      en: 'Idea Farm houses a diverse collection of specialised labs, ateliers, and production spaces covering woodwork, metal, ceramics, electronics, textiles, 2D and 3D printing, photo and video production, and more. These facilities support both in-house design and manufacturing, as well as artist residencies and collaborative projects.',
      sv: 'Idea Farm rymmer en mångsidig samling av specialiserade labb, ateljéer och produktionsytor för trä- och metallarbete, keramik, elektronik, textilier, 2D- och 3D-printing, foto- och videoproduktion och mycket mer. Dessa lokaler stödjer både intern design och produktion samt artistresidens och samarbeten.',
    },
    para2: {
      en: 'We also produce custom work to order - ranging from props for events to bespoke furniture and tailored electronic solutions. While our labs aren\'t open to the public like a typical makerspace, we do sometimes offer access for one-off projects or builds, if time and space allow.',
      sv: 'Vi producerar även skräddarsydda projekt på beställning — från rekvisita till evenemang, till specialbyggda möbler och anpassade elektroniska lösningar. Våra labb är inte öppna för allmänheten på samma sätt som ett traditionellt makerspace, men ibland erbjuder vi tillgång för enstaka projekt eller byggen, om tid och plats tillåter.',
    },
    collabLine1: {
      en: 'Have a skill, project, or idea that belongs here?',
      sv: 'Har du en färdighet, idé eller ett projekt som hör hemma här?',
    },
    collabLine2: {
      en: 'We\'re always open to collaborations - and',
      sv: 'Vi är alltid öppna för samarbeten — och',
    },
    collabLine3: {
      en: 'commissions too - Drop us a line',
      sv: 'beställningar. Kontakta oss',
    },
    here: { en: 'here', sv: 'här' },
  },

  // ===== HIRE PAGE =====
  hire: {
    intro: {
      en: 'Idea Farm offers a range of unique and flexible spaces for hire - perfect for events, creative retreats, pop-up studios, photo shoots, weddings and private parties. Get in touch!',
      sv: 'Idea Farm erbjuder en rad unika och flexibla lokaler för uthyrning — perfekta för evenemang, kreativa retreats, pop-up-studios, fotosessioner, bröllop och privata fester. Kontakta oss för mer information!',
    },
    kitchenTitle: { en: 'Kitchen/Venue', sv: 'Kök & Lokal' },
    kitchenDesc: {
      en: 'A welcoming, open-plan dining space with seating for up to 50 guests. One end features a fully equipped open kitchen - ideal for pop-up food events, catering, and culinary workshops. The other end includes a small stage area with an upright piano and PA system, making it perfect for intimate concerts, talks or recordings.',
      sv: 'Ett välkomnande, öppet matsalutrymme med plats för upp till 50 gäster. I ena änden finns ett fullutrustat öppet kök — perfekt för pop-up-mat, catering och kulinariska workshops. I andra änden finns en liten scen med pianon och PA-system, vilket gör lokalen idealisk för intima konserter, föreläsningar eller inspelningar.',
    },
    courtyardTitle: { en: 'Courtyard', sv: 'Gård & Uteplats' },
    courtyardDesc: {
      en: 'Our charming outdoor courtyard provides a versatile open-air venue surrounded by the beauty of the Swedish countryside. Perfect for summer gatherings, outdoor dining, and creative events under the stars.',
      sv: 'Vår charmiga uteplats erbjuder en flexibel utomhusmiljö omgiven av den svenska landsbygdens skönhet. Perfekt för sommarträffar, middagar utomhus och kreativa evenemang under stjärnorna.',
    },
    hayloftTitle: { en: 'Hayloft', sv: 'Höloftet' },
    hayloftDesc: {
      en: 'Once used to store grain and hay, this stunning upstairs space retains its original wooden shingle ceiling and a timeless rustic character. It\'s ideal for film screenings, yoga classes, workshops, photo shoots, and pop-up production offices.',
      sv: 'Tidigare använd för att förvara spannmål och hö, behåller detta fantastiska lokal på övervåningen sitt ursprungliga trä-tak med paneler och en tidlös, rustik karaktär. Perfekt för filmvisningar, yogaklasser, workshops, fotografering och pop-up-kontor för produktion.',
    },
    studioTitle: { en: 'Recording Studio', sv: 'Inspelningsstudio' },
    studioDesc: {
      en: 'Our 170 m² recording studio is also available for private event hire. With world class acoustics, 8m ceilings, vintage and modern equipment, and a full PA system, it\'s an inspiring space for songwriting retreats, creative corporate workshops, intimate concerts, and high-end production sessions.',
      sv: 'Vår 170 m² stora inspelningsstudio finns även tillgänglig för privata evenemang. Med världsklassakustik, 8 meter i takhöjd, vintage- och modern utrustning samt ett komplett PA-system, är studion en inspirerande miljö för songwriting-retreats, kreativa företagsworkshops, intima konserter och högkvalitativa produktionssessioner.',
    },
    bookNow: { en: 'Book Now', sv: 'Boka nu' },
  },

  // ===== ACCOMMODATION PAGE =====
  accommodation: {
    title: { en: 'Accommodation', sv: 'Boende' },
    description: {
      en: 'Our beautiful guesthouse is available to rent for creative retreats, while attending events, or just for a holiday',
      sv: 'Vårt vackra gästhus finns att hyra för kreativa retreats, under evenemang eller helt enkelt för en semester.',
    },
    bookNow: { en: 'Book now', sv: 'Boka nu' },
    otherOptions: {
      en: 'Other accommodation options also available, please get in touch for more details.',
      sv: 'Andra boendealternativ finns också — kontakta oss för mer information.',
    },
  },

  // ===== CONTACT / INFO PAGE =====
  newsletter: {
    optIn: {
      en: 'Click here to subscribe to our monthly newsletter!',
      sv: 'Klicka här för att prenumerera på vårt månatliga nyhetsbrev!',
    },
    linkText: {
      en: 'Subscribe to our events newsletter',
      sv: 'Prenumerera på vårt evenemangsnyhetsbrev',
    },
    linkHere: {
      en: 'HERE',
      sv: 'HÄR',
    },
  },
  contact: {
    contactUs: { en: 'Contact us', sv: 'Kontakta oss' },
    thankYou: {
      en: "Thank you for your message! We'll get back to you soon.",
      sv: 'Tack för ditt meddelande! Vi återkommer snart.',
    },
    thankYouNewsletter: {
      en: "Thank you for your message — and for subscribing to our newsletter! We'll get back to you soon.",
      sv: 'Tack för ditt meddelande – och för att du prenumererar på vårt nyhetsbrev! Vi återkommer snart.',
    },
    namePlaceholder: { en: 'Name *', sv: 'Namn *' },
    emailPlaceholder: { en: 'Email *', sv: 'E-post *' },
    phonePlaceholder: { en: 'Phone *', sv: 'Telefon *' },
    messagePlaceholder: { en: 'Message', sv: 'Meddelande' },
    send: { en: 'Send', sv: 'Skicka' },
    gettingHere: { en: 'Getting here', sv: 'Hitta hit' },

    // FAQ
    faq: { en: 'FAQ', sv: 'FAQ' },
    faqEvents: { en: 'Events', sv: 'Evenemang' },
    faqPayDoor: { en: 'Can I pay on the door?', sv: 'Kan jag betala vid entrén?' },
    faqPayDoorA: {
      en: 'We recommend purchasing tickets in advance to guarantee your spot and help us prepare for the event. If space allows, tickets may also be available at the door or during the evening.',
      sv: 'Vi rekommenderar att köpa biljetter i förväg för att garantera din plats och hjälpa oss förbereda evenemanget. Om plats finns kan biljetter även köpas vid entrén eller under kvällen.',
    },
    faqWhatTime: { en: 'What time does it start?', sv: 'När börjar det?' },
    faqWhatTimeA1: {
      en: 'For concerts the music usually starts at 20.00 and is finished by 22:30 unless otherwise stated.',
      sv: 'För konserter börjar musiken vanligtvis kl. 20.00 och är klar senast 22:30, om inget annat anges.',
    },
    faqWhatTimeA2: {
      en: 'Other events begin at the time stated on the specific event listing.',
      sv: 'Andra evenemang startar vid den tid som anges i respektive evenemangsbeskrivning.',
    },
    faqPrintedTicket: { en: 'Do I need a printed ticket?', sv: 'Behöver jag en utskriven biljett?' },
    faqPrintedTicketA: {
      en: "It's usually fine just to show the QR code on your phone.",
      sv: 'Det räcker oftast med att visa QR-koden på din mobil.',
    },
    faqAgeLimit: { en: 'Is there an age limit for events?', sv: 'Finns det åldersgräns för evenemang?' },
    faqAgeLimitA: {
      en: 'Some events have an age limit; please check the specific event listing for details.',
      sv: 'Vissa evenemang har åldersgräns; kontrollera respektive evenemangsbeskrivning för detaljer.',
    },
    faqAllergies: { en: 'And allergies for food events?', sv: 'Allergier vid mat-evenemang?' },
    faqAllergiesA: {
      en: 'If you have any food sensitivities/allergies please contact us in advance!',
      sv: 'Om du har matallergier eller känsligheter, kontakta oss i förväg.',
    },
    faqRefunds: { en: 'How about refunds?', sv: 'Hur fungerar återbetalning?' },
    faqRefundsA1: {
      en: 'For cancelled events a refund will be issued (minus booking fees) on the next working day.',
      sv: 'För inställda evenemang återbetalas biljettpriset (minus bokningsavgifter) nästa arbetsdag.',
    },
    faqRefundsA2: {
      en: "If you are no longer able to attend an event we ask for a minimum of 3 days' notice to guarantee a refund.",
      sv: 'Om du inte längre kan delta ber vi om minst tre dagars förvarning för att garantera återbetalning.',
    },
    faqRefundsA3: {
      en: 'For events curated by external promoters, customers will need to contact the relevant online seller to enquire about a refund.',
      sv: 'För evenemang arrangerade av externa promotörer måste kunder kontakta respektive biljettförsäljare för frågor om återbetalning.',
    },
    faqRefundsA4: {
      en: 'Please note that any booking fees are non-refundable.',
      sv: 'Observera att bokningsavgifter ej återbetalas.',
    },

    // Accessibility
    accessibility: { en: 'Accessibility', sv: 'Tillgänglighet' },
    accessibilityA1: {
      en: 'Idea Farm has step-free access and a wheelchair accessible toilet. Carers assisting at an event can enter free of charge.',
      sv: 'Idea Farm har trappfri tillgång och rullstolsanpassad toalett. Medföljande vårdare vid evenemang har fri entré.',
    },
    accessibilityA2: {
      en: 'Most events are a mixture of seated and standing (unless otherwise stated).',
      sv: 'De flesta evenemang är en blandning av sittande och stående platser (om inget annat anges).',
    },
    accessibilityA3: {
      en: 'Please email us if you require us to reserve a seat and we will do our best!',
      sv: 'Kontakta oss via e-post om du vill reservera en sittplats — vi gör vårt bästa för att ordna detta!',
    },

    // Address & Transport
    address: { en: 'Address', sv: 'Adress' },
    sweden: { en: 'Sweden', sv: 'Sverige' },
    byRoad: { en: 'By road', sv: 'Med bil' },
    parkingNotice: {
      en: 'There are designated parking spaces in the driveway. For larger events, signs will direct guests to designated parking areas.',
      sv: 'Det finns anvisade parkeringsplatser på gården. För större evenemang kommer skyltning att visa gäster till anvisade parkeringsplatser.',
    },
    publicTransport: { en: 'Public transport', sv: 'Kollektivtrafik' },
    trainTo: { en: 'Train to Klippan/Stehag', sv: 'Tåg till Klippan / Stehag' },
    busRoute: {
      en: 'Bus Route 518 to Ljungbyhed from Klippan ↔ Stehag',
      sv: 'Buslinje 518 till Ljungbyhed från Klippan ↔ Stehag',
    },
    walkGolf: {
      en: 'Then 25 min walk across the golf course.',
      sv: 'Sedan ca 25 minuters promenad över golfbanan.',
    },
    minibus: {
      en: 'Minibus service available for larger groups – please contact us in advance!',
      sv: 'Minibuss finns för större grupper – kontakta oss i förväg!',
    },

    // About Us
    aboutUs: { en: 'About Us', sv: 'Om oss' },
    elsaBio1: {
      en: ', born in Stockholm, started her career as a freelance portrait photographer, documenting the London celebrity, fashion, and music world for clients such as The Face, Vogue, Harper\'s Bazaar, The Guardian, The Independent and many more.',
      sv: ' växte upp i Stockholm men flyttade till London som 20-åring och började sin karriär som frilansande porträttfotograf. Där dokumenterade hon kändis-, mode- och musikvärlden för kunder som The Face, Vogue, Harper\'s Bazaar, The Guardian och The Independent.',
    },
    elsaBio2: {
      en: 'After developing a debilitating autoimmune disease in 2012, which was ultimately managed by changing her diet, she discovered the world of Functional Medicine — and a new mission: to help others in the same situation.',
      sv: 'Efter att ha drabbats av en autoimmun sjukdom 2012, som hon slutligen kunde hantera genom kostförändring, upptäckte hon Funktionsmedicin och fann ett nytt uppdrag: att hjälpa andra i samma situation.',
    },
    elsaBio3: {
      en: 'She now balances her photography career with her new role as a certified Functional Medicine health consultant and offers private sessions both in her clinic here at Idea Farm, and online.',
      sv: 'Idag kombinerar Elsa sin fotografikarriär med rollen som certifierad Functional Medicine-hälsokonsult, med privata sessioner både i sin klinik på Idea Farm och online.',
    },
    robbieBio1: {
      en: 'London-born Robbie Moore has worked in the music industry for the past 25 years — producing records, building recording studios, touring Europe, writing TV jingles, running record labels, and everything in between.',
      sv: 'Londonfödda Robbie Moore har under 25 år arbetat i musikbranschen — producerat skivor, byggt inspelningsstudior, turnerat i Europa, skrivit TV-jingles, drivit skivbolag och mycket mer.',
    },
    robbieBio2: {
      en: 'Having worked with everyone from Florence + the Machine to Little Simz, in 2014 he built Impression Recording studio in Berlin, which quickly became the top recording spot in the city.',
      sv: 'Han har samarbetat med artister som Florence + the Machine och Little Simz. 2014 byggde han Impression Recording Studio i Berlin, som snabbt blev en av stadens främsta inspelningsstudior.',
    },
    robbieBio3: {
      en: 'Ten years later, he is building its big sister at Idea Farm.',
      sv: 'Tio år senare bygger han nu dess "storasyster" här på Idea Farm.',
    },
  },

  // ===== EVENT DETAIL PAGE =====
  eventDetail: {
    doors: { en: 'Doors', sv: 'Dörrarna öppnar' },
    location: { en: 'Location', sv: 'Plats' },
    tickets: { en: 'Tickets', sv: 'Biljetter' },
    members: { en: 'MEMBERS', sv: 'MEDLEMMAR' },
    menu: { en: 'Menu', sv: 'Meny' },
    dietaryNote: {
      en: 'Have any dietary requirements? Let us know when booking and we\'ll tailor the menu for you!',
      sv: 'Har du särskilda kostbehov? Meddela oss vid bokning, så anpassar vi menyn efter dig!',
    },
  },

  // ===== FOOTER =====
  footer: {
    privacy: { en: 'Privacy policy ~ Integritetspolicy', sv: 'Integritetspolicy ~ Privacy policy' },
    terms: { en: 'Terms of Sale ~ Köpvillkor', sv: 'Köpvillkor ~ Terms of Sale' },
  },
};

export function t(key, language) {
  const keys = key.split('.');
  let value = translations;
  for (const k of keys) {
    value = value?.[k];
  }
  if (value && typeof value === 'object' && (value.en || value.sv)) {
    return value[language] || value.en;
  }
  return key; // fallback: return the key itself
}

export default translations;
